import { cx } from 'emotion'
import styled from 'react-emotion'
import { Flex } from 'shared/ui'
import Action from './Action'

const Actions = ({
  className,
  hideBcc = false,
  hideCc = false,
  hideFrom = false,
  hideSubject = false,
  onClick,
}) => {
  return (
    <Flex className={cx('actions', className)} ml={2}>
      {!hideSubject && <Action name={'subject'} onClick={onClick} />}
      {!hideFrom && <Action name={'from'} ml={3} onClick={onClick} />}
      {!hideCc && <Action name={'cc'} ml={3} onClick={onClick} />}
      {!hideBcc && <Action name={'bcc'} ml={3} onClick={onClick} />}
    </Flex>
  )
}

export default styled(Actions)`
  line-height: 24px;
  transform: translateY(-1px); /* visually center-align with rest of items */
`
